import type { ProfileData } from '@/features/profile/profileTypes';

import type { TourDefinition } from './tourTypes';

interface TourEligibilityParams {
  dismissedToursLoaded: boolean;
  isMobile: boolean;
  isTargetRegistered: boolean;
  locallyDismissedTourIds?: ReadonlySet<string>;
  profile: ProfileData | null | undefined;
  tour: TourDefinition;
}

export function doesTourAudienceMatch(
  profile:
    | Pick<ProfileData, 'isAssistant' | 'isInstructor'>
    | null
    | undefined,
  audience: TourDefinition['audience'],
) {
  if (!profile) {
    return false;
  }

  if (audience === 'shared') {
    return true;
  }

  if (profile.isAssistant) {
    return false;
  }

  if (audience === 'instructor') {
    return profile.isInstructor;
  }

  return !profile.isInstructor;
}

export function getDismissedTourSet(
  profile: Pick<ProfileData, 'dismissedTours'> | null | undefined,
  locallyDismissedTourIds: ReadonlySet<string> = new Set(),
) {
  return new Set([
    ...(profile?.dismissedTours ?? []),
    ...locallyDismissedTourIds,
  ]);
}

export function canAutoStartTour({
  dismissedToursLoaded,
  isMobile,
  isTargetRegistered,
  locallyDismissedTourIds,
  profile,
  tour,
}: TourEligibilityParams) {
  if (!dismissedToursLoaded || !profile || !isTargetRegistered) {
    return false;
  }

  if (tour.desktopOnly && isMobile) {
    return false;
  }

  if (!doesTourAudienceMatch(profile, tour.audience)) {
    return false;
  }

  return !getDismissedTourSet(profile, locallyDismissedTourIds).has(tour.id);
}
